import { MarkSpec } from 'prosemirror-model';

export const linkMarkSchema: MarkSpec = {
  attrs: {
    href: {},
    target: { default: '_blank' },
  },
  inclusive: false,
  parseDOM: [
    {
      tag: 'a[href]',
      getAttrs(dom) {
        return {
          href: (dom as HTMLElement).getAttribute('href'),
          target: (dom as HTMLElement).getAttribute('target') || '_blank',
        };
      },
    },
  ],
  toDOM(node) {
    const { href, target } = node.attrs;
    return ['a', { href, target }, 0];
  },
};
